import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import {
  ApiBusinessCard,
  AreaOfInterest,
  BusinessCard,
  EmployeeCount,
  titles,
  transformBusinessCard,
} from '@planone/bau365/util-user-data';
import { Country } from '@planone/shared/data-access-countries';
import { catchError, map, Observable, of } from 'rxjs';

import {
  BUSINESS_CARD_SERVICE_CONFIG,
  BusinessCardServiceConfigInterface,
} from '../config/business-card-service.config.interface';

@Injectable()
export class BusinessCardService {
  private apiUrl: string;

  constructor(
    private http: HttpClient,
    @Inject(BUSINESS_CARD_SERVICE_CONFIG) userServiceConfig: BusinessCardServiceConfigInterface
  ) {
    this.apiUrl = userServiceConfig.userServiceApiURL;
  }

  loadBusinessCard(id: string): Observable<BusinessCard | undefined> {
    return this.http.get<ApiBusinessCard>(`${this.apiUrl}/business-cards/${id}`).pipe(
      map((response) => transformBusinessCard(response)),
      catchError((error) => {
        if (error.status === 404) return of(undefined);
        throw error;
      })
    );
  }

  enrichBusinessCard(
    businessCard: BusinessCard,
    countries: Country[],
    employeeCountOptions: EmployeeCount[] | undefined,
    areaOfInterestOptions: AreaOfInterest[] | undefined
  ): Observable<BusinessCard> {
    return of({
      ...businessCard,
      title: titles.find((title) => title.key === businessCard.title)?.label,
      country_name: countries.find((country) => country.id === businessCard.country_name)?.name,
      employee_count:
        employeeCountOptions
          ?.filter((option) => option.id === businessCard.employee_count)
          .map((option) => option.text + $localize`:@@featureBusinessCard-employee: Mitarbeiter`)[0] ?? undefined,
      area_of_interest:
        areaOfInterestOptions
          ?.filter((option) => option.id === businessCard.area_of_interest)
          .map((option) => option.text)[0] ?? undefined,
    });
  }
}
